import React, { useState, useEffect, Suspense, useMemo } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import Routes from "../routes";
import { isMobile } from "react-device-detect";
import { getInsuranceCMSData, getInsuranceListAction, getMembershipCMSData } from "../admin/dashboard/actions";

import { useLocation } from "react-router-dom";
import Cookies from "universal-cookie";
import Loader from "../../components/loader";
import { getActiveAnnouncement, getShowAnnouncement } from "../admin/addAnnouncement/redux/selectors";
import DefaultMeta from "../../components/metas/defaultMeta";

const cookie = new Cookies();
const App = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const user_token = cookie.get("user_token");
  const user_info = useSelector((state) => state?.my_account?.user_info);
  const location = useLocation();
  const dispatch = useDispatch();

  const activeAnnouncement = useSelector(getActiveAnnouncement);
  const ahowAnn = useSelector(getShowAnnouncement);

  useEffect(() => {
    if (location?.pathname?.includes("admin")) {
      setIsAdmin(true);
    }
  }, [location]);

  // Global scroll to top
  window.onbeforeunload = function () {
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    dispatch(getMembershipCMSData());
    dispatch(getInsuranceCMSData());
    dispatch(getInsuranceListAction());
  }, []);

  const adminRoute = useMemo(() => {
    return (
      location.pathname.includes("/admin") &&
      location.pathname !== "/admin/addAnnouncement" &&
      location.pathname !== "/admin/list-announcement" &&
      location.pathname !== "/admin"
    );
  }, [location]);
  const liveAnnouncement = useMemo(() => !!(activeAnnouncement?.announcement && activeAnnouncement?.date && activeAnnouncement?.time), [activeAnnouncement]);

  return (
    <Suspense fallback={<Loader />}>
      <div
        className={`wrapper ${activeAnnouncement?.timer ? "" : "noTime"} ${!adminRoute && liveAnnouncement && ahowAnn ? "announcement" : ""} ${
          !adminRoute ? "admin_announcement" : ""
        } ${isMobile ? "mobileWrapper" : "desktopWrapper"} ${user_token !== undefined && user_info?.auth_token !== undefined ? "userLogin" : ""} ${
          isAdmin ? "admin" : ""
        }`}
      >
        <DefaultMeta />
        <Routes />
      </div>
    </Suspense>
  );
};
const mapStateToProps = () => ({});
export default connect(mapStateToProps)(App);
